import { AbstractControl, ValidatorFn } from '@angular/forms';

export const conditionalValidator = (condFn: (control: AbstractControl) => boolean, validators: ValidatorFn | ValidatorFn[]): ValidatorFn =>
  control => {
    if (!condFn(control)) {
      return null;
    }

    if (!Array.isArray(validators)) {
      return validators(control);
    }

    return validators.map(v => v(control)).reduce((errors, result) =>
      result === null ? errors : (Object.assign(errors || {}, result))
    );
  };
